export default __webpack_public_path__ + "static/media/oemer.43dc652f.png";